import { render } from "./DivisionView.vue?vue&type=template&id=e9ce3c16"
import script from "./DivisionView.vue?vue&type=script&lang=js"
export * from "./DivisionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__